import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionDailyPresenty = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const today = new Date().toISOString().split('T')[0];
    const [date, setDate] = useState(today);
    const [dailyPresentyList, setDailyPresentyList] = useState([]);
    const [teacherData, setTeacherData] = useState([]);
    const [error, setError] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [teacherNameSort, setTeacherNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["teacherName"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getDailyPresentyList();
    }, [date]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getDailyPresentyList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (date !== "") {
                setDailyPresentyList(await searchArray("B", `/get-daily-presenty?date=${date}&instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`, searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(dailyPresentyList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(dailyPresentyList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > dailyPresentyList.length) {
            endIndex = dailyPresentyList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(dailyPresentyList.slice(startIndex, endIndex));
    }, [dailyPresentyList, currPage, itemsPerPage]);


    const getDailyPresentyList = async () => {
        let apiUrl = `/get-daily-presenty?date=${date}&instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        apiUrl = apiUrl.replace(/&$/, '');

        try {
            const response = await authorizedAxiosSection.get(apiUrl);
            setDailyPresentyList(response.data.data);
            setTeacherNameSort(null);
        } catch (error) {
            setDailyPresentyList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleInputChange = (e) => {
        setDate(e.target.value);
    };

    const validateForm = () => {
        const invalidTeachers = dailyPresentyList.filter(teacher => teacher.dailyPresentyDetails.length === 0).map(teacher => teacher.id);
        const missingTeachers = invalidTeachers.filter(id => !teacherData.some(data => data.teacherMasterId === id));

        if (missingTeachers.length > 0) {
            setError(missingTeachers);
            return false;
        } else {
            setError([]);
            return true;
        }
    };

    const updateTeacherData = (teacherMasterId, event) => {
        const { value } = event.target;
        setTeacherData((prevData) => {
            const existingTeacherIndex = prevData.findIndex(teacher => teacher.teacherMasterId === teacherMasterId);

            if (existingTeacherIndex > -1) {
                const updatedData = [...prevData];
                updatedData[existingTeacherIndex].flag = value;
                return updatedData;
            } else {
                return [...prevData, { teacherMasterId, flag: value }];
            }
        });

        setError(prevError => prevError.filter(id => id !== teacherMasterId));
    };

    const updateTeacherAttendance = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                let apiUrl = `/add-bulk-edit-daily-presenty?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&date=${date}`;
                const response = await authorizedAxiosSection.post(apiUrl, teacherData);
                await getDailyPresentyList();
                Swal.fire({
                    text: response.data.message
                })
            } catch (error) {
                setDailyPresentyList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            } finally {
                setLoading(false);
            }
        }
    }

    const handleInputReset = () => {
        setDate("");
        setTeacherData([]);
        setDailyPresentyList([]);
        setError([]);
        setTeacherNameSort(null);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Daily Presenty</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-user-check"></i>Daily Presenty</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="date" className="col-form-label">Select Date :</label>
                                                    <input type="date" className="form-control" id="date" name='date' onChange={handleInputChange} value={date} max={today} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary " style={{ marginRight: '20px' }} type="button" onClick={updateTeacherAttendance}>Save</button>
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Teacher Name
                                                                            <SortIcon sortState={teacherNameSort} setSortState={setTeacherNameSort} setData={setDailyPresentyList} setCurrPage={setCurrPage} sortingPath={"teacherName"} />
                                                                        </th>
                                                                        <th scope="col">Attendance</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((teacher, index) => (
                                                                                <tr>
                                                                                    <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                    <td>{teacher.teacherName}</td>
                                                                                    <td>
                                                                                        <select className="form-select" aria-label="Default select example" name="flag"
                                                                                            value={
                                                                                                teacherData.some(data => data.teacherMasterId === teacher.id)
                                                                                                    ? teacherData.find(data => data.teacherMasterId === teacher.id).flag
                                                                                                    : teacher?.dailyPresentyDetails[0]?.flag || ""
                                                                                            }
                                                                                            onChange={(e) => updateTeacherData(teacher.id, e)}
                                                                                        >
                                                                                            <option value="" disabled>Select Attendance</option>
                                                                                            <option value={1}>Present</option>
                                                                                            <option value={2}>Absent</option>
                                                                                            <option value={3}>Half Day</option>
                                                                                        </select>
                                                                                        {error.includes(teacher.id) && (
                                                                                            <div className="error" style={{ color: 'red' }}>Select attendance status</div>
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Present List Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={dailyPresentyList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionDailyPresenty;